import { Currency } from "@faire/web/common/currencyConfig";

export const DEFAULT_CURRENCY: Currency = "USD";
